
// 个人信息类
let UserInfo = function () {
    this.qid = 0
    this.questionsTypeId = "" // 试题类型
    this.infoName = "" // 试题二级类型
    this.questionsName = ""
    this.isHideTitle = false // 是否隐藏该题
    this.mustanswer = true //是否必填
    this.format = 0
    this.minNum = 0 // 最小限制字数
    this.maxNum = 0 // 最大限制字数
    this.decimalPlaces = 0 // 保留小数位数
    this.placeholder = ''
    this.inputHeight = '小' 
}

export default UserInfo;